<template>
    <b-modal
        id="batch-recieve-modal"
        ref="batch-recieve-modal"
        title="Confirm Batch Recieve"
        size="lg"
        centered
        @ok="handleOk"
    >
        <div>
            <h4>The following samples have been received</h4>
            <ul>
                <li :key="idx" v-for="(sample, idx) in receivedList">
                    {{ sample.publicNumber() }}
                </li>
            </ul>
            <p>Press the 'Ok' button to send confirm the received samples.</p>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: "BatchRecieveModalConfirm",
    props: {
        receivedList: {
            type: Array,
            required: true,
        }
    },
    methods: {
        handleOk() {
            this.$emit('confirm')
        }
    },
}
</script>